import pixelLog from '../api/pixelLog'

export default {
    state: {
        pixelLog: []
    },
    namespaced: true,
    mutations: {
        async savePixelLogStore(state, pixelLog) {
            state.pixelLog = pixelLog
        },
    },
    actions: {
        async savePixelLogStore({ commit }, data) {
            commit('savePixelLogStore', await pixelLog.getPixelLog(data))
        },
    },
    getters: {
        getPixelLog: state => state.pixelLog
    },

}